import { powerUpBob } from '../../../../../../backend/store/playerProfile';
import Configs from '../../../../../../configs/Configs';
import Session from '../../../../session/Session';
import Button from '../../button/Button';
import Refresh from '../../refresh/Refresh';
import { SKILLS } from '../../../../../../configs/Configs';

const BUTTON_WIDTH = 326;
const BUTTON_OFFSET_X = 8;

export default class Bob extends Phaser.GameObjects.Container {
    private heroId: number = 1;
    private avatar!: Phaser.GameObjects.Image;
    private damage!: Button;
    private enrageTime!: Button;
    private enrageRefresh!: Refresh;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.heroId = 1;

        // this.setupAvatar();
        this.setupDamage();
        this.setupEnrageTime();
        this.setupEnrageRefresh();
    }

    // setupAvatar() {
    //     let x = 20;
    //     let y = 20;
    //     let frame = 'gui/footer/avatar_bob';

    //     this.avatar = this.scene.add.image(x, y, 'atlas', frame);
    //     this.avatar.setOrigin(0);
    //     this.add(this.avatar);
    // }

    setupDamage() {
        const w = this.scene.cameras.main.width / 2;
        const x = (w - BUTTON_WIDTH) / 2 + BUTTON_OFFSET_X;
        const y = 30;

        this.damage = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['upgrade_damage'], 'damage_level', 'bob');
        this.add(this.damage);

        this.damage.on('click', this.onDamageClick, this);
    }

    setupEnrageTime() {
        const w = this.scene.cameras.main.width / 2;
        const x = w + (w - BUTTON_WIDTH) / 2 - BUTTON_OFFSET_X;
        const y = 30;

        this.enrageTime = new Button(this.scene, x, y, this.scene.cache.json.get('i18n')['upgrade_enrage_time'], 'enrage_time', 'bob');
        this.add(this.enrageTime);

        this.enrageTime.on('click', this.onEnrageTimeClick, this);
    }

    setupEnrageRefresh() {
        const w = this.scene.cameras.main.width / 2;
        const x = (w - BUTTON_WIDTH) / 2 + BUTTON_OFFSET_X;
        const y = 150;

        this.enrageRefresh = new Refresh(this.scene, x, y);
        this.add(this.enrageRefresh);

        this.enrageRefresh.on('click', this.onEnrageRefreshClick, this);
        this.updateEnrageRefresh();
    }

    onDamageClick() {
        powerUpBob({ damage_level: 1 });
    }

    onEnrageTimeClick() {
        powerUpBob({ enrage_time: 1 });
    }

    updateEnrageRefresh() {
        let skill = SKILLS.BOB.ENRAGE_REFRESH;
        let level = Session.Instance.getSkillLevel(skill)!;

        let skillData = Configs.getBobSkill(skill, level);
        if (!skillData.canUpgrade) return this.enrageRefresh.setMaxedOut();

        this.enrageRefresh.update(skillData.value!); // value meaning price
    }

    onEnrageRefreshClick() {
        let success = Session.Instance.useEnrageRefresh();
        if (!success) return;
        this.updateEnrageRefresh();
    }

    show() {
        this.setVisible(true);
        this.setActive(true);
    }

    hide() {
        this.setVisible(false);
        this.setActive(false);
    }
}
